module.exports = __webpack_public_path__ + "static/media/dep7.fcdc9b18.jpg";